module.exports = __webpack_public_path__ + "img/img21.a6d7c3df.png";